import { animate, query, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  animations: [
    trigger('login', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(-200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
    trigger('register', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
  ]
})

export class AuthComponent implements OnInit {

  state = 'slideLeft';
  show = true;
  loading = false;

  constructor(
    public router: Router,
  ) { }

  ngOnInit(): void { }

  setTabs(tab: string): void {
    this.state === 'slideLeft' ? this.state = 'slideRight' : this.state = 'slideLeft';
    setTimeout(() => {
      switch (tab) {
        case 'login':
          this.show = true;
          break;
        case 'register':
          this.show = false;
          break;
        default:
          break;
      }
    }, 200);
  }
}
